var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar container"},[_c('nav-toggle'),_vm._v(" "),_c('breadcrumb',{attrs:{"path":_vm.breadcrumb}}),_vm._v(" "),(_vm.hasSettings)?_c('topbar-settings',{ref:"topbarSettings"},[_vm._t("settings",null,{slot:"settings"})],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57602b3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/TopBar.vue
// module id = null
// module chunks = 